import { removeFileExtension } from 'app/shared/utils/file.util';
import { Mediaclip } from 'app/interfaces/mediaclip';
import { FontsPipe } from './../pipes/fonts.pipe';
import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AssetService } from 'app/services/asset.service';

interface FontClip extends Mediaclip {
	isWebFont: boolean;
	fallback: string;
};

@Directive({
	selector: '[bbFont]'
})
export class BbFontDirective implements OnChanges {
	@Input('bbFont') fontClip: FontClip;
	assetBaseUrl: string;

	hostEl: HTMLElement;

	constructor(
		private el: ElementRef,
		private assetService: AssetService,
		private fontsPipe: FontsPipe
	) {	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.fontClip?.currentValue) {
			this.assetBaseUrl = this.assetService.getAssetBaseUrl();
			this.hostEl = this.el.nativeElement;
			const fontStyle = (this.fontClip.isWebFont ? '' : 'bb-select-') + removeFileExtension(this.fontClip.originalfilename) + (this.fontClip.fallback ? ', ' + this.fontClip.fallback : '');
			this.hostEl.style.fontFamily = fontStyle;
			this.fontsPipe.transform(this.fontClip.originalfilename, this.fontClip, this.assetBaseUrl);
		}
	}
}
